/**
 * 房树人测试 答题和报告的路由
 */

import {
  loadPageFail
} from '../lib/units';

export default [{
    name: 'answerHTP',
    path: '/answerHTP',
    meta: {
      title: '答题初始化页面'
    },
    component: resolve => require(['../pages/houseTreePeople/answer.vue'], resolve, (err) => {
      loadPageFail({
        pagename: '答题初始化页',
        err
      })
    }),
    // children: [{
    //     name: 'answerPainting',
    //     path: 'painting',
    //     meta: {
    //       title: '照片上传页',
    //     },
    //     component: resolve => require(['../pages/houseTreePeople/answerPainting.vue'], resolve, (err) => {
    //       loadPageFail({
    //         pagename: '照片上传页',
    //         err
    //       })
    //     })
    //   }
    // ]
  },
  {
    name:'reportHTP',
    path: '/reportHTP',
    meta: {
      title: '报告页',
    },
    component: resolve => require(['../pages/houseTreePeople/report.vue'], resolve),
  },
]



// WEBPACK FOOTER //
// ./src/router/houseTreePeople.js